<template>
  <div>
    <v-card class="overflow-hidden">
      <v-card-text>
        <v-row>
          <v-col>
            <customer-autocomplete-filter
              :fatherEditedCustomer="filterFix"
              :editedCustomerIndex="-1"
              :customerName="'quotation_customer_number'"
              @setFilterCustomer="setFilterCustomer"
            />
          </v-col>
          <v-col>
            <v-autocomplete
              :items="allFixType"
              item-text="Name"
              item-value="Type"
              :loading-text="$t('common_get_data')"
              :no-data-text="$t('common_no_results')"
              :label="$t('fix_type')"
              v-model="filterFix.FixType"
              @change="getFix"
            >
            </v-autocomplete>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('fix_number')"
              v-model="filterFix.FixNumber"
              @input="getFix"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              :label="$t('installation_notice_contact_name') + ' (1)'"
              v-model="filterFix.FirstContactName"
              @input="getFix"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('installation_notice_contact_phone') + ' (1)'"
              v-model="filterFix.FirstContactPhone"
              @input="getFix"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('installation_notice_contact_name') + ' (2)'"
              v-model="filterFix.SecondContactName"
              @input="getFix"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('installation_notice_contact_phone') + ' (2)'"
              v-model="filterFix.SecondContactPhone"
              @input="getFix"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-autocomplete
              :items="zoneList"
              item-text="Name"
              item-value="Type"
              :loading-text="$t('common_get_data')"
              :no-data-text="$t('common_no_results')"
              :label="$t('fix_zone')"
              v-model="filterFix.ZoneType"
              @change="getFix"
            >
            </v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              :items="allSpecialNeedList"
              item-text="Name"
              item-value="Id"
              :label="$t('quotation_special_need')"
              v-model="filterFix.SpecialNeedId"
              :loading-text="$t('common_get_data')"
              :no-data-text="$t('common_no_results')"
              @change="getFix"
            ></v-autocomplete>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_car_place')"
              v-model="filterFix.CarPlace"
              @input="getFix"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_license_plate')"
              v-model="filterFix.LicensePlate"
              @input="getFix"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-autocomplete
              :items="maintenanceEngineers"
              :label="$t('installation_notice_engineer')"
              v-model="filterFix.MaintenanceEngineer"
              item-text="NickName"
              item-value="UserName"
              :loading-text="$t('common_get_data')"
              :no-data-text="$t('common_no_results')"
              @change="getFix"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-checkbox
              v-model="filterFix.IsRange"
              :label="$t('installation_notice_is_range')"
              @click="setIsChange"
            ></v-checkbox>
          </v-col>
          <v-col v-if="!filterFix.IsRange">
            <v-text-field
              :label="$t('quotation_number')"
              v-model="filterFix.QuotationNumber"
              @input="getFix"
            ></v-text-field>
          </v-col>
          <v-col v-if="filterFix.IsRange">
            <v-text-field
              :label="$t('installation_notice_start_quotation_number')"
              v-model="filterFix.StartQuotationNumber"
              @input="getFix"
            ></v-text-field>
          </v-col>
          <v-col v-if="filterFix.IsRange">
            <v-text-field
              :label="$t('installation_notice_end_quotation_number')"
              v-model="filterFix.EndQuotationNumber"
              @input="getFix"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-data-table
      :headers="fixDataTableHeaders"
      :items="fixList"
      class="elevation-1 mt-5"
      :loading="isFixLoading"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :server-items-length="totalRows"
      :options="currentOptions"
      @update:options="updateOptions"
      :header-props="headerProps"
      item-key="Number"
      show-select
      v-model="selectedAuthFixList"
    >
      <template v-slot:[`item.contacts`]="{ item }">
        <div v-for="(c, idx) in getContacts(item)" :key="idx" class="text-caption mb-1">
          <span>{{ c.name || '-' }}</span>
          <span class="grey--text ml-1">{{ c.phone }}</span>
        </div>
        <span v-if="!getContacts(item).length" class="grey--text">-</span>
      </template>
      <template v-slot:[`item.Remarks`]="{ item }">
        <v-btn
          v-if="hasAnyRemark(item)"
          x-small
          text
          color="primary"
          @click="openRemarkDialog(item)"
        >
          {{ $t('common_view') }}
        </v-btn>
        <span v-else class="grey--text">-</span>
      </template>

      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('fix_tool_bar_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <select-auth-fix-done
            :selectedAuthFixList="selectedAuthFixList"
            @cleanSelectedAuthFixList="cleanSelectedAuthFixList"
            @updateSelectedAuthFixList="updateSelectedAuthFixList"
            @updateSelectedAuthFix="updateSelectedAuthFix"
          />
          <v-btn color="primary" dark class="mb-2 ml-8" @click="manyWork">
            {{ $t('installation_notice_many_work') }}
          </v-btn>
          <v-dialog persistent v-model="isShowStepDialog">
            <v-stepper v-model="stepNumber">
              <v-stepper-header>
                <v-stepper-step :complete="stepNumber > 1" step="1" :editable="stepNumber > 1">
                  {{ $t('installation_notice_step_bar1') }}
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :complete="stepNumber > 2" step="2" :editable="stepNumber > 2">
                  {{ $t('installation_notice_step_bar2') }}
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step step="3" :editable="stepNumber > 3">
                  {{ $t('installation_notice_step_bar3') }}
                </v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <ValidationObserver ref="dialogStepOne">
                        <ValidationProvider
                          :name="$t('installation_notice_engineer')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-autocomplete
                            :items="maintenanceEngineers"
                            item-text="NickName"
                            item-value="UserName"
                            v-model="selectMaintenanceEngineer"
                            :error-messages="errors[0]"
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('installation_notice_engineer') }}
                            </template>
                          </v-autocomplete>
                        </ValidationProvider>
                      </ValidationObserver>
                    </v-col>
                  </v-row>
                  <div style="margin-top:30px">
                    <v-btn class="ml-2" color="red" text @click="closeStepDialog">
                      {{ $t('common_close') }}
                    </v-btn>
                    <v-btn color="green" text @click="giveMaintenanceEngineer">
                      {{ $t('common_next') }}
                    </v-btn>
                  </div>
                </v-stepper-content>
                <v-stepper-content step="2">
                  <v-text-field
                    v-model="searchNotWorkFixList"
                    append-icon="mdi-magnify"
                    :label="$t('installation_notice_item_card_title')"
                    single-line
                    hide-details
                    class="mb-5"
                  ></v-text-field>
                  <v-data-table
                    :headers="selectedNotWorkFixDataTableHeaders"
                    :items="notWorkFixList"
                    item-key="Number"
                    class="elevation-1"
                    show-select
                    v-model="selectedWork"
                    :loading-text="$t('common_get_data')"
                    :no-data-text="$t('common_no_data')"
                    :no-results-text="$t('common_no_results')"
                    hide-default-footer
                    disable-pagination
                    :search="searchNotWorkFixList"
                    :header-props="headerProps"
                  >
                  </v-data-table>
                  <v-dialog v-model="remarkDialog" max-width="600">
                    <v-card>
                      <v-card-title>{{ $t('common_view') }}</v-card-title>
                      <v-card-text>
                        <div class="mb-4">
                          <div class="subtitle-2 grey--text">{{ $t('fix_dispatch_remark') }}</div>
                          <div>{{ remarkItem.Remark || '-' }}</div>
                        </div>
                        <div class="mb-4">
                          <div class="subtitle-2 grey--text">{{ $t('fix_internal_remark') }}</div>
                          <div>{{ remarkItem.InternalRemark || '-' }}</div>
                        </div>
                        <div>
                          <div class="subtitle-2 grey--text">{{ $t('fix_engineer_remark') }}</div>
                          <div>{{ remarkItem.EngineerRemark || '-' }}</div>
                        </div>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="remarkDialog = false">{{ $t('common_close') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <div style="margin-top:30px">
                    <v-btn class="ml-2" color="red" text @click="closeStepDialog">
                      {{ $t('common_close') }}
                    </v-btn>
                    <v-btn color="green" text @click="checkSelected">
                      {{ $t('common_next') }}
                    </v-btn>
                  </div>
                  <v-dialog v-model="isSelectWorkNullDialog" max-width="500" persistent>
                    <v-card color="error">
                      <v-card-title class="text-h1"></v-card-title>
                      <v-card-text class="white--text text-h5">
                        <v-icon class="white--text text--lighten-1">mdi-alert-octagon</v-icon>
                        {{ $t('installation_notice_next_alert') }}
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="white" text @click="isSelectWorkNullDialog = false">
                          {{ $t('common_close') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-stepper-content>

                <v-stepper-content step="3">
                  <v-data-table
                    :headers="fixDataTableHeaders"
                    :items="selectedWork"
                    item-key="Number"
                    class="elevation-1"
                    :loading-text="$t('common_get_data')"
                    :no-data-text="$t('common_no_data')"
                    :no-results-text="$t('common_no_results')"
                    hide-default-footer
                    disable-pagination
                    :header-props="headerProps"
                  >
                    <template v-slot:top>
                      <v-dialog v-model="isShowNotWorkEditFixDialog" persistent max-width="600px">
                        <v-card>
                          <v-card-title>
                            <span class="text-h5">{{
                              $t('installation_notice_step_card_title')
                            }}</span>
                          </v-card-title>
                          <v-card-text>
                            <v-container>
                              <v-row>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    :label="$t('installation_notice_else_point')"
                                    v-model="editedFix.ElsePoint"
                                    @keyup.enter="focusNextInput"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    :label="$t('installation_notice_else_point_reason')"
                                    v-model="editedFix.ElsePointReason"
                                    v-if="editedFix.ElsePoint != 0"
                                    @keyup.enter="focusNextInput"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click="closeUpdateEditedFixPoint">
                              {{ $t('common_close') }}
                            </v-btn>
                            <v-btn color="green darken-1" text @click="updateEditedFixPoint">
                              {{ $t('common_confirm') }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </template>
                    <template v-slot:[`item.Edit`]="{ item }">
                      <v-btn icon @click="isShowEditFixDialogBtn(item)">
                        <v-icon small>
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                      <v-btn
                        v-if="
                          editedFix.FixType === fixType.RepairFix ||
                            editedFix.FixType === fixType.TryInstallRepairFix
                        "
                        icon
                        @click="isShowDeleteFixDialogBtn(item)"
                      >
                        <v-icon small>
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </template>
                    <template v-slot:[`item.SpecialNeedList`]="{ item }">
                      {{ turnSpecialNeedName(item.SpecialNeedList) }}
                    </template>
                    <template v-slot:[`item.FixType`]="{ item }">
                      {{ turnFixType(item) }}
                    </template>
                    <template v-slot:[`item.ZoneType`]="{ item }">
                      {{ turnZoneTypeName(item.ZoneType) }}
                    </template>
                  </v-data-table>
                  <div style="margin-top:30px">
                    <v-btn class="ml-2" color="red" text @click="closeStepDialog">
                      {{ $t('common_close') }}
                    </v-btn>
                    <v-btn color="green" text @click="manyPointAndMaintenanceEngineerUpdate">
                      {{ $t('installation_notice_is_work') }}
                    </v-btn>
                  </div>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-dialog>
          <v-btn color="primary" dark class="mb-2 ml-8" @click="openEditedDialog">
            {{ $t('common_new') }}
          </v-btn>
          <v-dialog v-model="isShowEditFixDialog" fullscreen persistent>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ editFixDialogTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-row class="mt-2">
                  <v-btn
                    color="primary"
                    @click="checkWorkPhoto"
                    :disabled="
                      isAllTextFieldDisable ||
                        editedFix.IsWork ||
                        editedFix.IsDone ||
                        editedFix.IsCancel
                    "
                    class="mx-2"
                    v-if="
                      editedFix.FixType !== fixType.MovieLook &&
                        editedFix.FixType !== fixType.Info &&
                        editedFix.FixType !== fixType.Prepayment &&
                        editedFix.FixType !== fixType.Complaint &&
                        editedFix.FixType !== fixType.AuthorizeInstall &&
                        editedFix.FixType !== fixType.AuthorizeRemove &&
                        editedFixIndex !== -1
                    "
                  >
                    {{ $t('installation_notice_is_work') }}
                  </v-btn>
                  <info-dialog
                    :isShowDialog="isShowCheckWorkPhoto"
                    :message="infoMessage"
                    @closeDialog="closeInfoDialog"
                    @confirmDialog="isWorkBtn"
                  ></info-dialog>
                  <!-- <v-btn
                    color="primary"
                    @click="isShowThrowDialog = true"
                    :disabled="
                      (editedFix.FixType !== fixType.RemoveFix &&
                        editedFix.FixType !== fixType.MoveFix) ||
                        editedFix.IsCancel ||
                        editedFix.IsWork ||
                        editedFix.IsThrowToResume
                    "
                    class="mx-2"
                  >
                    轉拋履歷卡
                  </v-btn>
                  <v-dialog v-model="isShowThrowDialog" persistent>
                    <v-card>
                      <v-card-title class="text-h5"></v-card-title>
                      <v-card-text>
                        <ValidationObserver ref="setDoneTime">
                          <v-row>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <date-picker-set-time
                                :time="editedFix.DoneTime"
                                :dateName="'month_quotation_done_time'"
                                :isAllTextFieldDisabled="isAllTextFieldDisable"
                                @setDate="setDoneTime"
                                @keyupEnter="focusNextInput"
                              />
                            </v-col>
                          </v-row>
                        </ValidationObserver>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="isShowThrowDialog = false">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="isThrowResumeBtn">
                          {{ $t('common_confirm') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog> -->

                  <v-btn
                    color="primary"
                    @click="isShowCancelDialog = true"
                    :disabled="
                      isAllTextFieldDisable ||
                        editedFix.IsCancel ||
                        editedFix.IsWork ||
                        editedFix.IsDone
                    "
                    class="mx-2"
                    v-if="editedFixIndex !== -1"
                  >
                    {{ $t('common_cancel') }}
                  </v-btn>

                  <v-btn
                    color="primary"
                    class="mx-2"
                    :disabled="editedFixIndex === -1"
                    @click="copyCurrentFix"
                  >
                    {{ $t('fix_copy') }}
                  </v-btn>
                  <v-dialog v-model="isShowCancelDialog" persistent>
                    <v-card>
                      <v-card-title class="text-h5">
                        {{ $t('fix_cancel_reason_title') }}
                      </v-card-title>
                      <v-card-text>
                        <v-textarea
                          outlined
                          v-model="returnReason.Reason"
                          :label="$t('fix_cancel_reason')"
                        ></v-textarea>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="isShowCancelDialog = false">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="isCancelBtn">
                          {{ $t('common_confirm') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-btn
                    color="primary"
                    :disabled="editedFix.IsWork || editedFix.IsDone"
                    class="mx-2"
                    v-if="
                      editedFixIndex !== -1 &&
                        (editedFix.FixType === fixType.AuthorizeInstall ||
                          editedFix.FixType === fixType.AuthorizeRemove)
                    "
                    @click="checkThrowPhoto"
                  >
                    {{ $t('fix_throw_authorize_resume') }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="editedFix.IsWork || editedFix.IsDone"
                    class="mx-2"
                    v-if="
                      editedFixIndex !== -1 &&
                        (editedFix.FixType === fixType.MovieLook ||
                          editedFix.FixType === fixType.Info ||
                          editedFix.FixType === fixType.Prepayment ||
                          editedFix.FixType === fixType.Complaint)
                    "
                    @click="checkDonePhoto"
                  >
                    {{ $t('fix_done') }}
                  </v-btn>
                  <info-dialog
                    :isShowDialog="isShowCheckDonePhoto"
                    :message="infoMessage"
                    @closeDialog="closeInfoDialog"
                    @confirmDialog="updateDoneReason"
                  ></info-dialog>
                  <input
                    type="file"
                    ref="file"
                    style="display: none"
                    multiple="multiple"
                    @change="uploadPhoto"
                  />
                  <v-btn
                    fab
                    text
                    small
                    color="primary"
                    @click="openFileDialog"
                    :disabled="isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone"
                    v-if="editedFixIndex !== -1"
                  >
                    <v-icon>
                      mdi-paperclip
                    </v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <div style="color:red; margin-right:100px" v-if="editedFix.IsCancel">
                    <v-icon color="error">
                      mdi-alert-box
                    </v-icon>
                    {{ $t('fix_status_cancelled') }}
                  </div>
                  <div
                    style="color:red; margin-right:100px"
                    v-if="!editedFix.IsWork && !editedFix.IsDone && !editedFix.IsCancel"
                  >
                    <v-icon color="error">
                      mdi-alert-box
                    </v-icon>
                    {{ $t('installation_notice_status_false') }}
                  </div>
                  <div style="color:green; margin-right:100px" v-if="editedFix.IsDone">
                    <v-icon color="success">
                      mdi-checkbox-marked-outline
                    </v-icon>
                    {{ $t('fix_status') }}
                  </div>
                  <div style="color:green; margin-right:100px" v-if="editedFix.IsWork">
                    <v-icon color="success">
                      mdi-checkbox-marked-outline
                    </v-icon>
                    {{ $t('installation_notice_status_true') }}
                  </div>
                </v-row>
              </v-card-text>
              <v-tabs v-model="fixTab">
                <v-tab href="#tab-1">{{ $t('fix_tab_title') }}</v-tab>
                <v-tab
                  href="#tab-2"
                  v-if="editedFix.FileNameList && editedFix.FileNameList.length > 0"
                  >{{ $t('fix_photo') }}</v-tab
                >
                <v-tab href="#tab-3">{{ $t('installation_notice_record') }}</v-tab>
                <v-tab href="#tab-4">{{ $t('quotation_tab_third') }}</v-tab>
                <v-tab-item value="tab-1">
                  <v-card flat>
                    <v-card-text>
                      <v-container>
                        <ValidationObserver ref="dialogEditedFix">
                          <v-row>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('fix_type')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-autocomplete
                                  :items="computedFixType"
                                  item-text="Name"
                                  item-value="Type"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  v-model="editedFix.FixType"
                                  :error-messages="errors[0]"
                                  :disabled="
                                    isAllTextFieldDisable ||
                                      editedFix.IsWork ||
                                      editedFix.IsDone ||
                                      editedFixIndex !== -1
                                  "
                                  @keyup.enter="setFixTypeAutocomplete"
                                  ref="fixTypeAutocomplete"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('fix_type') }}
                                  </template>
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('fix_number')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedFix.Number"
                                  disabled
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('fix_number') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="computedCreateTime"
                                :label="$t('installation_notice_create_time')"
                                disabled
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <customer-autocomplete
                                :fatherEditedCustomer="editedFix"
                                :editedCustomerIndex="-1"
                                :customerName="'quotation_customer_number'"
                                @setCustomer="setCustomer"
                                v-if="editedFixIndex === -1"
                                refName="customerAutocomplete"
                                @keyupEnter="focusNextInput"
                              />
                              <ValidationProvider
                                :name="$t('quotation_customer_number')"
                                rules="required"
                                v-slot="{ errors }"
                                v-else
                              >
                                <v-text-field
                                  v-model="editedFix.CustomerNumber"
                                  :error-messages="errors[0]"
                                  disabled
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_customer_number') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('quotation_shortname')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedFix.CustomerName"
                                  disabled
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_shortname') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('quotation_full_name')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedFix.CustomerFullName"
                                  disabled
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_full_name') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('quotation_license_plate')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedFix.LicensePlate"
                                  :disabled="
                                    isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone
                                  "
                                  @keyup.enter="focusNextInput"
                                  @change="setResumeItem"
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_license_plate') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('fix_zone')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-autocomplete
                                  :items="zoneList"
                                  item-text="Name"
                                  item-value="Type"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  v-model="editedFix.ZoneType"
                                  :error-messages="errors[0]"
                                  :disabled="
                                    isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone
                                  "
                                  @keyup.enter="setZoneAutocomplete"
                                  ref="zoneAutocomplete"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('fix_zone') }}
                                  </template>
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="editedFix.CarPlace"
                                :label="$t('quotation_car_place')"
                                :disabled="
                                  isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone
                                "
                                @keyup.enter="focusNextInput"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-autocomplete
                                :items="allSpecialNeedList"
                                item-text="Name"
                                item-value="Name"
                                :label="$t('quotation_special_need')"
                                :disabled="
                                  isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone
                                "
                                v-model="editedFix.SpecialNeedList"
                                :loading-text="$t('common_get_data')"
                                :no-data-text="$t('common_no_results')"
                                small-chips
                                multiple
                                return-object
                                @keydown.enter="setKeyDownAutocomplete"
                                @keyup.enter="setKeyUpAutocomplete"
                                ref="specialNeedAutocomplete"
                              ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-text-field
                                v-model="editedFix.Brand"
                                :disabled="
                                  isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone
                                "
                                @keyup.enter="focusNextInput"
                                label="廠牌/車型"
                              >
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <div
                            v-if="
                              editedFix.FixType !== fixType.MovieLook &&
                                editedFix.FixType !== fixType.Info &&
                                editedFix.FixType !== fixType.Prepayment &&
                                editedFix.FixType !== fixType.Complaint &&
                                editedFix.FixType !== fixType.AuthorizeInstall &&
                                editedFix.FixType !== fixType.AuthorizeRemove
                            "
                          >
                            <v-row>
                              <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                                {{ $t('engineer_first_contact') }}
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('installation_notice_contact_name')"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedFix.FirstContactName"
                                    :error-messages="errors[0]"
                                    :disabled="
                                      isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone
                                    "
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      {{ $t('installation_notice_contact_name') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('installation_notice_contact_phone')"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedFix.FirstContactPhone"
                                    :error-messages="errors[0]"
                                    :disabled="
                                      isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone
                                    "
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      {{ $t('installation_notice_contact_phone') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                                {{ $t('engineer_second_contact') }}
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedFix.SecondContactName"
                                  :label="$t('installation_notice_contact_name')"
                                  :disabled="
                                    isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone
                                  "
                                  @keyup.enter="focusNextInput"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedFix.SecondContactPhone"
                                  :label="$t('installation_notice_contact_phone')"
                                  :disabled="
                                    isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone
                                  "
                                  @keyup.enter="focusNextInput"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                                {{ $t('engineer_third_contact') }}
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedFix.ThirdContactName"
                                  :label="$t('installation_notice_contact_name')"
                                  :disabled="
                                    isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone
                                  "
                                  @keyup.enter="focusNextInput"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedFix.ThirdContactPhone"
                                  :label="$t('installation_notice_contact_phone')"
                                  :disabled="
                                    isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone
                                  "
                                  @keyup.enter="focusNextInput"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row v-if="editedFixIndex !== -1">
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-autocomplete
                                  :items="maintenanceEngineers"
                                  item-text="NickName"
                                  item-value="UserName"
                                  v-model="editedFix.MaintenanceEngineer"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  :disabled="
                                    isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone
                                  "
                                  @keyup.enter="setEngineerAutocomplete"
                                  ref="engineerAutocomplete"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('installation_notice_engineer') }}
                                  </template>
                                </v-autocomplete>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('installation_notice_point')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedFix.Point"
                                    :label="$t('installation_notice_point')"
                                    disabled
                                    :error-messages="errors[0]"
                                  ></v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('installation_notice_else_point')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedFix.ElsePoint"
                                    :label="$t('installation_notice_else_point')"
                                    :disabled="
                                      isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone
                                    "
                                    :error-messages="errors[0]"
                                    @keyup.enter="focusNextInput"
                                  ></v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('installation_notice_else_point_reason')"
                                  v-if="editedFix.ElsePoint != 0"
                                  :rules="{ required: true }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedFix.ElsePointReason"
                                    v-if="editedFix.ElsePoint != 0"
                                    :disabled="
                                      isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone
                                    "
                                    :error-messages="errors[0]"
                                    required
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('installation_notice_else_point_reason') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                          </div>
                          <div
                            v-if="
                              editedFix.FixType === fixType.RemoveFix ||
                                editedFix.FixType === fixType.MoveFix
                            "
                          >
                            <v-row>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedFix.QuotationNumber"
                                  :label="$t('repair_quotation_number')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedFix.QuotationName"
                                  :label="$t('repair_quotation_name')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedFix.QuotationToFixThrowUser.Name"
                                  :label="$t('fix_throw_notice_by')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="computedTime"
                                  :label="$t('fix_throw_notice_time')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row v-if="editedFixIndex !== -1">
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="turnWorkDate"
                                  :label="$t('installation_notice_work_date')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="turnWorkBy"
                                  :label="$t('installation_notice_work_by')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </div>
                          <v-row
                            v-if="
                              editedFix.FixType === fixType.MovieLook ||
                                editedFix.FixType === fixType.Info ||
                                editedFix.FixType === fixType.Prepayment ||
                                editedFix.FixType === fixType.Complaint ||
                                editedFix.FixType === fixType.AuthorizeInstall ||
                                editedFix.FixType === fixType.AuthorizeRemove
                            "
                          >
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <date-picker-set-time
                                :time="editedFix.DoneTime"
                                :dateName="'fix_done_time'"
                                :isAllTextFieldDisabled="
                                  isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone
                                "
                                @setDate="setDoneTime"
                                @keyupEnter="focusNextInput"
                                v-if="
                                  editedFix.FixType === fixType.AuthorizeInstall ||
                                    editedFix.FixType === fixType.AuthorizeRemove
                                "
                              />
                              <v-text-field
                                v-model="turnDoneDate"
                                :label="$t('fix_done_time')"
                                disabled
                                v-else
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="editedFix.DoneBy"
                                label="完工人員"
                                disabled
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row
                            v-if="
                              editedFix.FixType === fixType.MovieLook ||
                                editedFix.FixType === fixType.Info ||
                                editedFix.FixType === fixType.Prepayment ||
                                editedFix.FixType === fixType.Complaint ||
                                editedFix.FixType === fixType.AuthorizeInstall ||
                                editedFix.FixType === fixType.AuthorizeRemove
                            "
                          >
                            <v-col>
                              <ValidationProvider
                                :name="$t('fix_done_reason')"
                                :rules="{ required: true }"
                                v-slot="{ errors }"
                              >
                                <v-textarea
                                  v-model="editedFix.DoneReason"
                                  outlined
                                  :error-messages="errors[0]"
                                  :disabled="
                                    isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone
                                  "
                                  @keyup.enter="focusNextInput"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('fix_done_reason') }}
                                  </template>
                                </v-textarea>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <ValidationProvider
                                :name="$t('fix_reason')"
                                :rules="{ required: true }"
                                v-slot="{ errors }"
                                v-if="
                                  editedFix.FixType === fixType.RepairFix ||
                                    editedFix.FixType === fixType.TryInstallRepairFix
                                "
                              >
                                <v-textarea
                                  v-model="editedFix.FixReason"
                                  :error-messages="errors[0]"
                                  :disabled="
                                    isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone
                                  "
                                  outlined
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('fix_reason') }}
                                  </template>
                                </v-textarea>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="4">
                              <v-textarea
                                outlined
                                v-model="editedFix.Remark"
                                :label="$t('fix_dispatch_remark')"
                                :disabled="
                                  isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone
                                "
                                rows="3"
                              ></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="4">
                              <v-textarea
                                v-model="editedFix.InternalRemark"
                                :label="$t('fix_internal_remark')"
                                :disabled="
                                  isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone
                                "
                                rows="3"
                                outlined
                              ></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="4">
                              <v-textarea
                                v-model="editedFix.EngineerRemark"
                                :label="$t('fix_engineer_remark')"
                                :disabled="
                                  isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone
                                "
                                rows="3"
                                outlined
                              ></v-textarea>
                            </v-col>
                          </v-row>
                        </ValidationObserver>
                      </v-container>
                    </v-card-text>
                    <v-data-table
                      :headers="fixItemDataTableHeaders"
                      :items="computedFixItem"
                      class="elevation-1 my-5 mx-5"
                      :search="searchFixItem"
                      :loading-text="$t('common_get_data')"
                      :no-data-text="$t('common_no_data')"
                      :no-results-text="$t('common_no_results')"
                      :footer-props="{
                        'items-per-page-options': [30, 50, 100],
                        'items-per-page-text': $t('item_rows_per_page'),
                      }"
                      :header-props="headerProps"
                      item-key="Index"
                      :show-select="
                        editedFix.FixType === fixType.TryInstallFix ||
                          editedFix.FixType === fixType.TryInstallRepairFix
                      "
                      v-model="selectedFixItems"
                      v-if="
                        editedFix.FixType === fixType.TryInstallRepairFix ||
                          (editedFix.FixItems && editedFix.FixItems.length > 0)
                      "
                    >
                      <template v-slot:top>
                        <v-toolbar flat>
                          <v-toolbar-title>{{ $t('fix_item_toolbar_title') }}</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-text-field
                            v-model="searchFixItem"
                            append-icon="mdi-magnify"
                            :label="$t('installation_notice_item_card_title')"
                            single-line
                            hide-details
                            clearable
                          ></v-text-field>
                          <v-btn
                            color="primary"
                            class="mb-2 ml-8"
                            @click="deleteFixItems"
                            v-if="
                              editedFix.FixType === fixType.TryInstallFix ||
                                editedFix.FixType === fixType.TryInstallRepairFix
                            "
                            :disabled="isAllTextFieldDisable || selectedFixItems.length === 0"
                          >
                            {{ $t('common_delete') }}
                          </v-btn>
                          <v-btn
                            color="primary"
                            dark
                            class="mb-2 ml-8"
                            v-if="editedFix.FixType === fixType.TryInstallRepairFix"
                            :disabled="isAllTextFieldDisable || editedFix.IsWork"
                            @click="isShowEditFixItemDialog = true"
                          >
                            {{ $t('common_new') }}
                          </v-btn>
                          <v-dialog
                            v-model="isShowEditFixItemDialog"
                            v-if="isShowEditFixItemDialog"
                            persistent
                          >
                            <v-card>
                              <v-card-title>
                                <span class="text-h5"></span>
                              </v-card-title>
                              <v-card-text>
                                <v-container>
                                  <ValidationObserver ref="dialogEditedFixItem">
                                    <v-row>
                                      <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                        <ValidationProvider
                                          :name="$t('installation_notice_item_buy_or_rent')"
                                          rules="required"
                                          v-slot="{ errors }"
                                        >
                                          <v-autocomplete
                                            v-model="editedFixItem.BuyOrRentType"
                                            :items="allBuyOrRentType"
                                            item-text="Name"
                                            item-value="Type"
                                            required
                                            :loading-text="$t('common_get_data')"
                                            :no-data-text="$t('common_no_results')"
                                            ref="buyOrRentTypeAutocomplete"
                                            @keyup.enter="setBuyOrRentType"
                                            :error-messages="errors[0]"
                                            :disabled="
                                              editedFixItem.Type === 'Z100000000' ||
                                                editedFixItemIndex !== -1
                                            "
                                            @change="changeBuyOrRentType"
                                          >
                                            <template v-slot:label>
                                              <span class="red--text">
                                                <strong>* </strong>
                                              </span>
                                              {{ $t('installation_notice_item_buy_or_rent') }}
                                            </template>
                                          </v-autocomplete>
                                        </ValidationProvider>
                                      </v-col>
                                    </v-row>
                                    <v-row>
                                      <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                        <quotation-item-for-repair-price-autocomplete
                                          :fatherEditedItem="editedFixItem"
                                          :editedItemIndex="editedFixItemIndex"
                                          :itemName="'quotation_item_number'"
                                          :repairCustomerId="editedFix.CustomerId"
                                          :customerDeviceType="editedFixItem.CustomerDeviceType"
                                          @setEditedItem="setEditedItem"
                                          v-if="
                                            editedFixItemIndex === -1 &&
                                              editedFixItem.BuyOrRentType === 2
                                          "
                                          @keyupEnter="focusNextInput"
                                          refName="itemAutocomplete"
                                        />
                                        <quotation-item-autocomplete
                                          :fatherEditedItem="editedFixItem"
                                          :editedItemIndex="editedFixItemIndex"
                                          :itemName="'quotation_item_number'"
                                          :customerDeviceType="editedFixItem.CustomerDeviceType"
                                          @setEditedItem="setEditedItem"
                                          v-else-if="
                                            editedFixItemIndex === -1 &&
                                              (editedFixItem.BuyOrRentType === 1 ||
                                                editedFixItem.BuyOrRentType === 3)
                                          "
                                          refName="itemAutocomplete"
                                          @keyupEnter="focusNextInput"
                                        />
                                        <ValidationProvider
                                          :name="$t('quotation_item_number')"
                                          rules="required"
                                          v-slot="{ errors }"
                                          v-else
                                        >
                                          <v-text-field
                                            v-model="editedFixItem.Number"
                                            :error-messages="errors[0]"
                                            disabled
                                          >
                                            <template v-slot:label>
                                              <span class="red--text">
                                                <strong>* </strong>
                                              </span>
                                              {{ $t('quotation_item_number') }}
                                            </template>
                                          </v-text-field>
                                        </ValidationProvider>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                        <ValidationProvider
                                          :name="$t('quotation_item_name')"
                                          rules="required"
                                          v-slot="{ errors }"
                                        >
                                          <v-text-field
                                            v-model="editedFixItem.Name"
                                            disabled
                                            :error-messages="errors[0]"
                                          >
                                            <template v-slot:label>
                                              <span class="red--text">
                                                <strong>* </strong>
                                              </span>
                                              {{ $t('quotation_item_name') }}
                                            </template>
                                          </v-text-field>
                                        </ValidationProvider>
                                      </v-col>
                                    </v-row>
                                    <v-row>
                                      <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                        <ValidationProvider
                                          :name="$t('quotation_remove_item_quantity')"
                                          :rules="{ required: true, regex: /^[0-9]+$/ }"
                                          v-slot="{ errors }"
                                        >
                                          <v-text-field
                                            v-model="editedFixItem.Quantity"
                                            required
                                            :disabled="
                                              editedFixItem.HasSerialNumber ||
                                                editedFixItem.InstallPosition > 0
                                            "
                                            @keyup.enter="focusNextInput"
                                            :error-messages="errors[0]"
                                          >
                                            <template v-slot:label>
                                              <span class="red--text">
                                                <strong>* </strong>
                                              </span>
                                              {{ $t('quotation_remove_item_quantity') }}
                                            </template>
                                          </v-text-field>
                                        </ValidationProvider>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                        <ValidationProvider
                                          :name="$t('quotation_item_unit')"
                                          rules="required"
                                          v-slot="{ errors }"
                                        >
                                          <v-text-field
                                            v-model="editedFixItem.Unit"
                                            required
                                            disabled
                                            :error-messages="errors[0]"
                                          >
                                            <template v-slot:label>
                                              <span class="red--text">
                                                <strong>* </strong>
                                              </span>
                                              {{ $t('quotation_item_unit') }}
                                            </template>
                                          </v-text-field>
                                        </ValidationProvider>
                                      </v-col>
                                    </v-row>
                                    <v-row>
                                      <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                        <v-autocomplete
                                          v-model="editedFixItem.InstallPosition"
                                          :items="allInstallPositionType"
                                          item-text="Name"
                                          item-value="Type"
                                          :label="$t('quotation_item_install_position')"
                                          :loading-text="$t('common_get_data')"
                                          :no-data-text="$t('common_no_results')"
                                          ref="installPositionAutocomplete"
                                          @keyup.enter="setInstallPosition"
                                          @change="setInstallPositionQuantity"
                                        ></v-autocomplete>
                                      </v-col>
                                    </v-row>
                                    <v-row>
                                      <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                        <v-checkbox
                                          v-model="editedFixItem.IsCustomerDevice"
                                          :label="$t('quotation_item_is_customer_device')"
                                          @change="changeIsCustomerDevice"
                                          :disabled="editedFixItem.BuyOrRentType === 1"
                                        ></v-checkbox>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                        <v-autocomplete
                                          v-model="editedFixItem.CustomerDeviceType"
                                          :items="customerDeviceTypeList"
                                          item-text="Name"
                                          item-value="Type"
                                          :label="$t('engineer_item_customer_device_type')"
                                          :loading-text="$t('common_get_data')"
                                          :no-data-text="$t('common_no_results')"
                                          v-if="editedFixItem.IsCustomerDevice"
                                          ref="deviceTypeAutocomplete"
                                          @keyup.enter="setCustomerDeviceType"
                                        ></v-autocomplete>
                                      </v-col>
                                    </v-row>
                                    <v-row>
                                      <v-col>
                                        <v-textarea
                                          outlined
                                          :label="$t('quotation_item_remark')"
                                          v-model="editedFixItem.Remark"
                                        ></v-textarea>
                                      </v-col>
                                    </v-row>
                                  </ValidationObserver>
                                </v-container>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="red darken-1" text @click="closeEditFixItem">
                                  {{ $t('common_cancel') }}
                                </v-btn>
                                <v-btn color="green darken-1" text @click="addFixItem">
                                  {{ $t('common_save') }}
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>

                          <v-btn
                            color="primary"
                            class="mb-2 ml-8"
                            @click="isShowFixItemEditedBomDialog = true"
                            v-if="editedFix.FixType === fixType.TryInstallRepairFix"
                            :disabled="isAllTextFieldDisable || editedFix.IsWork"
                          >
                            {{ $t('quotation_item_new_install_new_bom_btn') }}
                          </v-btn>
                          <v-dialog
                            v-if="isShowFixItemEditedBomDialog"
                            v-model="isShowFixItemEditedBomDialog"
                            persistent
                          >
                            <v-card>
                              <v-card-title>
                                <span class="text-h5"></span>
                              </v-card-title>

                              <v-card-text>
                                <v-container>
                                  <ValidationObserver ref="bomRepairItem">
                                    <v-row>
                                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                        <ValidationProvider
                                          :name="$t('installation_notice_item_buy_or_rent')"
                                          rules="required"
                                          v-slot="{ errors }"
                                        >
                                          <v-autocomplete
                                            v-model="editedFixItemBom.BuyOrRentType"
                                            :items="allBuyOrRentType"
                                            item-text="Name"
                                            item-value="Type"
                                            required
                                            :loading-text="$t('common_get_data')"
                                            :no-data-text="$t('common_no_results')"
                                            ref="buyOrRentTypeAutocomplete"
                                            @keyup.enter="setBuyOrRentType"
                                            :error-messages="errors[0]"
                                            @change="changeBuyOrRentType"
                                          >
                                            <template v-slot:label>
                                              <span class="red--text">
                                                <strong>* </strong>
                                              </span>
                                              {{ $t('installation_notice_item_buy_or_rent') }}
                                            </template>
                                          </v-autocomplete>
                                        </ValidationProvider>
                                      </v-col>
                                      <v-col
                                        cols="12"
                                        sm="6"
                                        md="3"
                                        lg="3"
                                        xl="3"
                                        v-if="
                                          editedFixItemBom.BuyOrRentType === 1 ||
                                            editedFixItemBom.BuyOrRentType === 3
                                        "
                                      >
                                        <quotation-bom-autocomplete
                                          :fatherEditedItem="editedFixItemBom"
                                          :editedItemIndex="editedFixItemIndex"
                                          :itemName="'quotation_item_number'"
                                          :repairCustomerId="editedFix.CustomerId"
                                          :customerDeviceType="editedFixItemBom.CustomerDeviceType"
                                          @setBomItem="setBomItem"
                                          v-if="editedFixItemIndex === -1"
                                          @keyupEnter="focusNextInput"
                                          refName="bomNameAutocomplete"
                                        />
                                      </v-col>
                                      <v-col cols="12" sm="6" md="4" lg="3" xl="3" v-else>
                                        <quotation-bom-for-repair-price-autocomplete
                                          :fatherEditedItem="editedFixItemBom"
                                          :editedItemIndex="editedFixItemIndex"
                                          :itemName="'quotation_item_number'"
                                          :repairCustomerId="editedFix.CustomerId"
                                          :customerDeviceType="editedFixItemBom.CustomerDeviceType"
                                          @setBomItem="setBomItem"
                                          v-if="editedFixItemIndex === -1"
                                          @keyupEnter="focusNextInput"
                                          refName="bomNameAutocomplete"
                                        />
                                      </v-col>
                                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                        <v-text-field
                                          v-model="editedFixItemBom.Describe"
                                          disabled
                                          label="主設備描述"
                                        >
                                        </v-text-field>
                                      </v-col>
                                    </v-row>
                                    <v-row>
                                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                        <ValidationProvider
                                          :name="$t('quotation_item_quantity')"
                                          :rules="{ required: true, regex: /^[0-9]+$/ }"
                                          v-slot="{ errors }"
                                        >
                                          <v-text-field
                                            v-model="editedFixItemBom.Quantity"
                                            :error-messages="errors[0]"
                                          >
                                            <template v-slot:label>
                                              <span class="red--text">
                                                <strong>* </strong>
                                              </span>
                                              {{ $t('quotation_item_quantity') }}
                                            </template>
                                          </v-text-field>
                                        </ValidationProvider>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                        <v-autocomplete
                                          v-model="editedFixItemBom.InstallPositions"
                                          :items="allInstallPositionType"
                                          item-text="Name"
                                          item-value="Type"
                                          :label="$t('quotation_item_install_position')"
                                          :loading-text="$t('common_get_data')"
                                          :no-data-text="$t('common_no_results')"
                                          small-chips
                                          multiple
                                          @change="setInstallPositionListQuantity"
                                        ></v-autocomplete>
                                      </v-col>
                                    </v-row>
                                    <v-row>
                                      <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                                        <v-checkbox
                                          v-model="editedFixItemBom.IsCustomerDevice"
                                          :label="$t('quotation_item_is_customer_device')"
                                          @change="changeIsCustomerDevice"
                                          :disabled="editedFixItemBom.BuyOrRentType === 1"
                                        ></v-checkbox>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                        <v-autocomplete
                                          v-model="editedFixItemBom.CustomerDeviceType"
                                          :items="customerDeviceTypeList"
                                          item-text="Name"
                                          item-value="Type"
                                          :label="$t('engineer_item_customer_device_type')"
                                          :loading-text="$t('common_get_data')"
                                          :no-data-text="$t('common_no_results')"
                                          v-if="editedFixItemBom.IsCustomerDevice"
                                          ref="deviceTypeAutocomplete"
                                          @keyup.enter="setCustomerDeviceType"
                                        ></v-autocomplete>
                                      </v-col>
                                    </v-row>
                                  </ValidationObserver>
                                </v-container>
                              </v-card-text>

                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="red darken-1"
                                  text
                                  @click="closeEditedFixItemBomDialog"
                                  :disabled="isAllTextFieldDisable"
                                >
                                  {{ $t('common_cancel') }}
                                </v-btn>
                                <v-btn color="green darken-1" text @click="addEditedFixItemBom">
                                  {{ $t('common_confirm') }}
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                          <delete-dialog
                            :isAllTextFieldDisable="false"
                            :isLoadingSaveBtn="false"
                            :isShowDeleteDialog="isShowDeleteFixItemDialog"
                            :deleteMessage="'fix_item_delete_dialog_message'"
                            @closeDelete="closeDeleteFixItem"
                            @confirmDelete="confirmDeleteFixItem"
                          />
                          <!-- <v-dialog v-model="isFixItemNullDialog" max-width="500" persistent>
                      <v-card color="error">
                        <v-card-title class="text-h1"></v-card-title>
                        <v-card-text class="white--text text-h5">
                          <v-icon class="white--text text--lighten-1">mdi-alert-octagon</v-icon>
                          {{ $t("fix_item_save_alert") }}
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="white" text @click="isFixItemNullDialog = false">
                            {{ $t("common_close") }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog> -->
                        </v-toolbar>
                      </template>
                      <template v-slot:[`item.InstallPosition`]="{ item }">
                        {{ turnData(item.InstallPosition) }}
                      </template>
                      <template v-slot:[`item.BuyOrRentType`]="{ item }">
                        {{ turnBuyOrRentType(item.BuyOrRentType) }}
                      </template>
                      <template v-slot:[`item.Edit`]="{ item }">
                        <v-icon
                          small
                          class="mr-2"
                          :disabled="editedFix.IsWork"
                          v-if="editedFix.FixType === fixType.TryInstallRepairFix"
                          @click="isShowEditFixItemDialogBtn(item)"
                        >
                          mdi-pencil
                        </v-icon>
                        <v-icon
                          small
                          class="mr-2"
                          :disabled="editedFix.IsWork"
                          v-if="editedFix.FixType === fixType.TryInstallRepairFix"
                          @click="isShowDeleteFixItemDialogBtn(item)"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
                <v-tab-item value="tab-2">
                  <!-- <v-card v-for="fixImage in fixImageList" :key="fixImage" max-width="30%">
                    <v-img :src="fixImage"></v-img>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="red" class="text--white"> 刪除</v-btn>
                    </v-card-actions>
                  </v-card> -->
                  <!-- <v-row>
                    <v-col cols="2" v-for="(fixImage, index) in fixImageList" :key="fixImage">
                      <v-card flat>
                        <v-img :src="fixImage"></v-img>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="error" @click="deletePhoto(index)">{{
                            $t('common_delete')
                          }}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row> -->
                  <photo-gallery :editedFix="editedFix" :fixTab="fixTab" @searchFix="searchFix" />
                </v-tab-item>
                <v-tab-item value="tab-3">
                  <v-card flat>
                    <v-card-text>
                      <v-data-table
                        :headers="recordListDataTableHeaders"
                        :items="editedFix.RecordList"
                        class="elevation-1 my-5 mx-5"
                        :loading-text="$t('common_get_data')"
                        :no-data-text="$t('common_no_data')"
                        :no-results-text="$t('common_no_results')"
                        :footer-props="{
                          'items-per-page-options': [30, 50, 100],
                          'items-per-page-text': $t('item_rows_per_page'),
                        }"
                        :header-props="headerProps"
                      >
                        <template v-slot:[`item.RecordType`]="{ item }">
                          {{ turnRecordType(item.RecordType) }}
                        </template>
                        <template v-slot:[`item.CreateTime`]="{ item }">
                          {{ convertToDateTimeFormat(item.CreateTime) }}
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item value="tab-4">
                  <v-card flat>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <v-text-field
                              v-model="editedFix.TpAccount"
                              label="環保帳號"
                              :disabled="
                                isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone
                              "
                              @keyup.enter="focusNextInput"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <v-text-field
                              v-model="editedFix.TpPassword"
                              label="環保密碼"
                              :disabled="
                                isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone
                              "
                              @keyup.enter="focusNextInput"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="closeEditedFix"
                  :disabled="isLoadingSaveBtn"
                >
                  {{ $t('common_cancel') }}
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="saveEditedFix"
                  :loading="isLoadingSaveBtn"
                  :disabled="isAllTextFieldDisable || editedFix.IsWork || editedFix.IsDone"
                >
                  {{ $t('common_save') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <delete-dialog
            :isAllTextFieldDisable="false"
            :isLoadingSaveBtn="isLoadingSaveBtn"
            :isShowDeleteDialog="isShowDeleteFixDialog"
            :deleteMessage="'fix_item_delete_dialog_message'"
            @closeDelete="closeDeleteFix"
            @confirmDelete="confirmDeleteFix"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn icon @click="isShowEditFixDialogBtn(item)">
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>
        <v-btn
          v-if="
            editedFix.FixType === fixType.RepairFix ||
              editedFix.FixType === fixType.TryInstallRepairFix
          "
          icon
          @click="isShowDeleteFixDialogBtn(item)"
        >
          <v-icon small>
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.IsWork`]="{ item }">
        <v-icon v-if="item.IsWork">
          mdi-check
        </v-icon>
        <v-icon v-else>
          mdi-close
        </v-icon>
      </template>
      <template v-slot:[`item.IsDone`]="{ item }">
        <v-icon v-if="item.IsDone">
          mdi-check
        </v-icon>
        <v-icon v-else>
          mdi-close
        </v-icon>
      </template>
      <template v-slot:[`item.FixType`]="{ item }">
        {{ turnFixType(item) }}
      </template>
      <template v-slot:[`item.ZoneType`]="{ item }">
        {{ turnZoneTypeName(item.ZoneType) }}
      </template>
      <template v-slot:[`item.SpecialNeedList`]="{ item }">
        {{ turnSpecialNeedName(item.SpecialNeedList) }}
      </template>
    </v-data-table>

    <v-dialog v-model="remarkDialog" max-width="560">
      <v-card>
        <v-card-title class="text-h6">
          {{ $t('fix_remark') }}
          <v-spacer></v-spacer>
          <v-btn icon @click="remarkDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="4" class="grey--text">{{ $t('fix_number') }}</v-col>
            <v-col cols="8">{{ remarkItem.Number || '-' }}</v-col>
            <v-col cols="4" class="grey--text">{{ $t('quotation_customer_number') }}</v-col>
            <v-col cols="8">{{ remarkItem.CustomerName || '-' }}</v-col>
            <v-col cols="4" class="grey--text">{{ $t('quotation_license_plate') }}</v-col>
            <v-col cols="8">{{ remarkItem.LicensePlate || '-' }}</v-col>
          </v-row>
          <v-divider class="my-3"></v-divider>
          <div class="mb-2">
            <div class="subtitle-2">{{ $t('fix_engineer_remark') }}</div>
            <div style="white-space: pre-wrap">{{ remarkItem.EngineerRemark || '-' }}</div>
          </div>
          <div class="mb-2">
            <div class="subtitle-2">{{ $t('fix_internal_remark') }}</div>
            <div style="white-space: pre-wrap">{{ remarkItem.InternalRemark || '-' }}</div>
          </div>
          <div>
            <div class="subtitle-2">{{ $t('fix_dispatch_remark') }}</div>
            <div style="white-space: pre-wrap">
              {{ remarkItem.DispatchRemark || remarkItem.Remark || '-' }}
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="remarkDialog = false">{{ $t('common_close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<style scoped>
.red {
  background-color: red !important;
}
</style>
<script>
import {
  HttpFix,
  HttpInstallationAcceptance,
  HttpResume,
  HttpUser,
  HttpTpManager,
  HttpSpecialNeed,
  HttpQuotation,
  HttpInstallPosition
} from '@/js/http-Manager'
import { ItemInstallPositionType } from '@/js/ItemInstallPositionType'
import { FixType } from '@/js/FixType'
import { extend } from 'vee-validate'
import { regex } from 'vee-validate/dist/rules'
import CustomerAutocompleteFilter from '@/components/CustomerAutocompleteFilter.vue'
import CustomerAutocomplete from '@/components/CustomerAutocomplete.vue'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { BuyOrRentType } from '@/js/BuyOrRentType'
import { ZoneType } from '@/js/ZoneType'
import { RecordType } from '@/js/RecordType'
import InfoDialog from '@/components/InfoDialog.vue'
import QuotationBomForRepairPriceAutocomplete from '@/components/Quotation/BomAutocomplete/QuotationBomForRepairPriceAutocomplete.vue'
import QuotationBomAutocomplete from '@/components/Quotation/BomAutocomplete/QuotationBomAutocomplete.vue'
import QuotationItemForRepairPriceAutocomplete from '@/components/Quotation/ItemAutocomplete/QuotationItemForRepairPriceAutocomplete.vue'
import QuotationItemAutocomplete from '@/components/Quotation/ItemAutocomplete/QuotationItemAutocomplete.vue'
import DatePickerSetTime from '@/components/DatePickerSetTime.vue'
import SelectAuthFixDone from '@/components/Fix/SelectAuthFixDone.vue'
import PhotoGallery from '@/components/PhotoGallery.vue'

extend('regex', regex)
export default {
  components: {
    CustomerAutocompleteFilter,
    CustomerAutocomplete,
    DeleteDialog,
    InfoDialog,
    QuotationBomForRepairPriceAutocomplete,
    QuotationBomAutocomplete,
    QuotationItemForRepairPriceAutocomplete,
    QuotationItemAutocomplete,
    DatePickerSetTime,
    SelectAuthFixDone,
    PhotoGallery
  },
  name: 'Fix',
  data: () => ({
    remarkDialog: false,
    remarkItem: {},
    fixTab: 'tab-1',
    selectedFixItems: [],
    fixType: FixType,
    isShowCheckWorkPhoto: false,
    isShowCheckDonePhoto: false,
    infoMessage: '',
    isShowEditFixDialog: false,
    fixList: [],
    editedFixIndex: -1,
    editedFix: {
      CustomerId: '',
      FixType: 3,
      Number: '',
      FixReason: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      FirstContactName: '',
      FirstContactPhone: '',
      SecondContactName: '',
      SecondContactPhone: '',
      ThirdContactName: '',
      ThirdContactPhone: '',
      CarPlace: '',
      QuotationNumber: '',
      QuotationName: '',
      LicensePlate: '',
      Point: 1,
      ElsePoint: 0,
      ElsePointReason: '',
      MaintenanceEngineer: '',
      IsWork: false,
      FixToRepairThrowUser: {
        ThrowTime: 0,
        Name: ''
      },
      FixItems: [],
      IsDone: false,
      DoneReason: '',
      QuotationToFixThrowUser: {
        ThrowTime: 0,
        Name: ''
      },
      ZoneType: 6,
      Subject: '',
      FileNameList: [],
      RecordList: [],
      SpecialNeedList: [],
      TpAccount: '',
      TpPassword: '',
      CreateTime: 0,
      Brand: '',
      IsCancel: false,
      IsThrowToResume: false,
      DoneTime: 0,
      DoneBy: ''
    },
    defaultFix: {
      CustomerId: '',
      FixType: 3,
      Number: '',
      FixReason: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      FirstContactName: '',
      FirstContactPhone: '',
      SecondContactName: '',
      SecondContactPhone: '',
      ThirdContactName: '',
      ThirdContactPhone: '',
      CarPlace: '',
      QuotationNumber: '',
      QuotationName: '',
      LicensePlate: '',
      Point: 1,
      ElsePoint: 0,
      ElsePointReason: '',
      MaintenanceEngineer: '',
      IsWork: false,
      FixToRepairThrowUser: {
        ThrowTime: 0,
        Name: ''
      },
      FixItems: [],
      IsDone: false,
      DoneReason: '',
      QuotationToFixThrowUser: {
        ThrowTime: 0,
        Name: ''
      },
      ZoneType: 6,
      Subject: '',
      FileNameList: [],
      RecordList: [],
      SpecialNeedList: [],
      TpAccount: '',
      TpPassword: '',
      CreateTime: 0,
      Brand: '',
      IsCancel: false,
      IsThrowToResume: false,
      DoneTime: 0,
      DoneBy: ''
    },
    isFixLoading: true,
    isLoadingSaveBtn: false,
    isAllTextFieldDisable: false,
    totalRows: 0,
    currentOptions: {
      page: 1,
      itemsPerPage: 30,
      sortBy: ['Number'],
      sortDesc: [true],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      triggerByOutsite: true
    },
    isUpdateEventTotal: true,

    filterFix: {
      CustomerId: '',
      FixType: 0,
      FixNumber: '',
      LicensePlate: '',
      MaintenanceEngineer: '',
      FirstContactName: '',
      FirstContactPhone: '',
      SecondContactName: '',
      SecondContactPhone: '',
      CarPlace: '',
      ZoneType: 0,
      SpecialNeedId: '',
      IsRange: false,
      QuotationNumber: '',
      StartQuotationNumber: '',
      EndQuotationNumber: ''
    },

    editedFixItemIndex: -1,
    searchFixItem: '',
    stepNumber: 1,
    isShowStepDialog: false,
    selectedWork: [],
    notWorkFixList: [],
    isShowNotWorkEditFixDialog: false,
    selectMaintenanceEngineer: '',
    isSelectWorkNullDialog: false,
    maintenanceEngineers: [],
    searchNotWorkFixList: '',
    allFixType: [],
    isShowFixItemEditedBomDialog: false,
    editedFixItemBom: {
      Id: '',
      Describe: '',
      Name: '',
      BomItems: [],
      Quantity: 0,
      BuyOrRentType: 0,
      IsCustomerDevice: false,
      CustomerDeviceType: 0,
      InstallPositions: []
    },
    defaultFixItemBom: {
      Id: '',
      Describe: '',
      Name: '',
      BomItems: [],
      Quantity: 0,
      BuyOrRentType: 0,
      IsCustomerDevice: false,
      CustomerDeviceType: 0,
      InstallPositions: []
    },
    editedFixItem: {
      ItemId: '',
      Number: '',
      Name: '',
      Unit: '',
      Quantity: 0,
      RealQuantity: 0,
      BuyOrRentType: 0,
      WarrantyPeriod: 0,
      IsCustomerDevice: false,
      InstallPosition: 0,
      HasSerialNumber: false,
      IsOutOfWarranty: false,
      Reason: '',
      Custody: 0,
      Remark: '',
      CustomerDeviceType: 0
    },
    defaultFixItem: {
      ItemId: '',
      Number: '',
      Name: '',
      Unit: '',
      Quantity: 0,
      RealQuantity: 0,
      BuyOrRentType: 0,
      WarrantyPeriod: 0,
      IsCustomerDevice: false,
      InstallPosition: 0,
      HasSerialNumber: false,
      IsOutOfWarranty: false,
      Reason: '',
      Custody: 0,
      Remark: '',
      CustomerDeviceType: 0
    },
    allBuyOrRentType: [],
    allInstallPositionType: [],
    isShowEditFixItemDialog: false,
    isShowDeleteFixItemDialog: false,
    isShowDeleteFixDialog: false,
    isFixItemNullDialog: false,
    allCustodyType: [],
    zoneList: [],
    fixImageList: [],
    allSpecialNeedList: [],
    editedTpManager: {
      CustomerId: '',
      LicensePlate: '',
      TpAccount: '',
      TpPassword: ''
    },
    defaultTpManager: {
      CustomerId: '',
      LicensePlate: '',
      TpAccount: '',
      TpPassword: ''
    },
    specialNeedList: [],
    customerDeviceTypeList: [],
    isShowCancelDialog: false,
    returnReason: {
      Reason: '',
      Number: '',
      NumberType: 11,
      IsCancel: false
    },
    defaultReason: {
      Reason: '',
      Number: '',
      NumberType: 11,
      IsCancel: false
    },
    isShowThrowDialog: false,
    selectedAuthFixList: []
  }),
  watch: {},
  async mounted () {
    await this.getFix()
    await this.countTotalRows()
    await this.getBuyOrRentType()
    await this.getAllInstallPositionType()
    await this.getFixType()
    await this.getAllCustodyType()
    await this.getZoneType()
    await this.getEngineerUser()
    await this.getSpecialNeedList()
    await this.getCustomerDeviceType()
  },
  computed: {
    fixDataTableHeaders () {
      return [
        {
          text: this.$t('fix_type'),
          align: 'start',
          value: 'FixType',
          sortable: false
        },
        {
          text: this.$t('fix_number'),
          align: 'start',
          value: 'Number'
        },

        {
          text: this.$t('quotation_customer_number'),
          align: 'start',
          value: 'CustomerNumber',
          sortable: false
        },
        {
          text: this.$t('quotation_shortname'),
          align: 'start',
          value: 'CustomerName',
          sortable: false
        },
        {
          text: this.$t('quotation_full_name'),
          align: 'start',
          value: 'CustomerFullName',
          sortable: false
        },
        {
          text: this.$t('quotation_license_plate'),
          align: 'start',
          value: 'LicensePlate'
        },
        {
          text: this.$t('installation_notice_contact'),
          align: 'start',
          value: 'contacts',
          sortable: false,
          width: '200px'
        },
        {
          text: this.$t('fix_zone'),
          align: 'start',
          value: 'ZoneType'
        },
        {
          text: this.$t('quotation_car_place'),
          align: 'start',
          value: 'CarPlace'
        },
        {
          text: this.$t('installation_notice_engineer'),
          align: 'start',
          value: 'EngineerNickName'
        },
        {
          text: this.$t('quotation_special_need'),
          align: 'start',
          value: 'SpecialNeedList'
        },
        {
          text: this.$t('installation_notice_point'),
          align: 'start',
          value: 'Point'
        },
        { text: this.$t('installation_notice_else_point'), align: 'start', value: 'ElsePoint' },
        {
          text: this.$t('fix_remark'),
          align: 'center',
          value: 'Remarks',
          sortable: false,
          width: '100px'
        },
        {
          text: this.$t('installation_notice_is_work'),
          align: 'center',
          value: 'IsWork',
          sortable: false
        },
        {
          text: this.$t('fix_done'),
          align: 'center',
          value: 'IsDone',
          sortable: false
        },
        {
          text: this.$t('common_edit'),
          align: 'center',
          value: 'Edit',
          sortable: false
        }
      ]
    },
    selectedNotWorkFixDataTableHeaders () {
      return [
        {
          text: this.$t('installation_notice_number'),
          align: 'start',
          value: 'Number'
        },
        {
          text: this.$t('fix_subject'),
          align: 'start',
          value: 'Subject'
        },
        {
          text: this.$t('quotation_customer_number'),
          align: 'start',
          value: 'CustomerNumber',
          sortable: false
        },
        {
          text: this.$t('quotation_shortname'),
          align: 'start',
          value: 'CustomerName',
          sortable: false
        },
        {
          text: this.$t('quotation_shortname'),
          align: 'start',
          value: 'CustomerFullName',
          sortable: false
        },
        {
          text: this.$t('quotation_license_plate'),
          align: 'start',
          value: 'LicensePlate'
        },
        {
          text: this.$t('installation_notice_engineer'),
          align: 'start',
          value: 'EngineerNickName'
        },
        {
          text: this.$t('installation_notice_is_work'),
          align: 'center',
          value: 'IsWork',
          sortable: false
        }
      ]
    },
    fixItemDataTableHeaders () {
      return [
        {
          text: this.$t('installation_notice_item_main_name'),
          align: 'start',
          value: 'BomName'
        },
        {
          text: this.$t('quotation_item_number'),
          align: 'start',
          value: 'Number'
        },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        {
          text: this.$t('quotation_item_quantity'),
          align: 'end',
          value: 'Quantity'
        },
        {
          text: this.$t('installation_notice_item_buy_or_rent'),
          align: 'start',
          value: 'BuyOrRentType'
        },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'SerialNumber'
        },
        {
          text: this.$t('quotation_item_is_customer_device'),
          align: 'start',
          value: 'IsCustomerDevice'
        },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'InstallPosition'
        },
        {
          text: this.$t('common_edit'),
          align: 'center',
          value: 'Edit',
          sortable: false
        }
      ]
    },
    computedTime () {
      if (
        this.editedFix.QuotationToFixThrowUser.ThrowTime !== 0 ||
        this.editedFix.QuotationToFixThrowUser
      ) {
        return this.convertToDateTimeFormat(this.editedFix.QuotationToFixThrowUser.ThrowTime)
      }
      return this.convertToDateTimeFormat(0)
    },
    computedCreateTime () {
      if (this.editedFix.CreateTime !== 0) {
        return this.convertToDateTimeFormat(this.editedFix.CreateTime)
      }
      return this.convertToDateTimeFormat(0)
    },
    turnWorkDate () {
      if (this.editedFix.FixToRepairThrowUser) {
        return this.convertToDateTimeFormat(this.editedFix.FixToRepairThrowUser.ThrowTime)
      }
      return this.convertToDateTimeFormat(0)
    },
    turnWorkBy () {
      if (this.editedFix.FixToRepairThrowUser) {
        return this.editedFix.FixToRepairThrowUser.Name
      }
      return ''
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    editFixDialogTitle () {
      return this.editedFixIndex === -1 ? this.$t('common_new') : this.$t('common_edit')
    },
    computedFixItem () {
      let array = []
      if (this.editedFix.FixItems) {
        this.editedFix.FixItems.forEach((element, index) => {
          array.push(
            Object.assign(
              {
                Index: index + 1
              },
              element
            )
          )
        })
      }

      return array
    },
    recordListDataTableHeaders () {
      return [
        {
          text: this.$t('installation_notice_work_by'),
          align: 'start',
          value: 'WorkNickName'
        },
        {
          text: this.$t('month_item_status'),
          align: 'start',
          value: 'RecordType'
        },
        {
          text: this.$t('installation_notice_engineer'),
          align: 'start',
          value: 'EngineerNickName'
        },
        {
          text: this.$t('installation_notice_engineer_number'),
          align: 'start',
          value: 'Number'
        },
        {
          text: this.$t('installation_notice_time'),
          align: 'start',
          value: 'CreateTime'
        },
        {
          text: this.$t('installation_notice_reason'),
          align: 'start',
          value: 'Reason'
        }
      ]
    },
    computedFixType () {
      let array = []
      this.allFixType.forEach((element) => {
        array.push(
          Object.assign(
            {
              disabled:
                element.Type === this.fixType.RemoveFix || element.Type === this.fixType.MoveFix
            },
            element
          )
        )
      })
      return array
    },
    turnDoneDate () {
      return this.convertToDateTimeFormat(this.editedFix.DoneTime)
    }
  },
  methods: {
    async copyCurrentFix () {
      const res = await HttpFix.MakeFixNumber()
      const newNumber = res.status === 200 ? res.data.Data : ''

      const copied = JSON.parse(JSON.stringify(this.editedFix))
      copied.Id = null
      copied.Number = newNumber
      copied.IsWork = false
      copied.IsDone = false
      copied.IsCancel = false
      copied.IsThrowToResume = false
      copied.FileNameList = []
      copied.Subject = '報修新增'

      this.editedFix = copied
      this.editedFixIndex = -1
      this.isAllTextFieldDisable = false
    },
    getContacts (item) {
      const list = []
      if (item.FirstContactName || item.FirstContactPhone) {
        list.push({ name: item.FirstContactName, phone: item.FirstContactPhone })
      }
      if (item.SecondContactName || item.SecondContactPhone) {
        list.push({ name: item.SecondContactName, phone: item.SecondContactPhone })
      }
      if (item.ThirdContactName || item.ThirdContactPhone) {
        list.push({ name: item.ThirdContactName, phone: item.ThirdContactPhone })
      }
      return list
    },
    hasAnyRemark (item) {
      return !!(item.Remark || item.InternalRemark || item.EngineerRemark)
    },
    openRemarkDialog (item) {
      this.remarkItem = item
      this.remarkDialog = true
    },

    setDoneTime (val) {
      this.editedFix.DoneTime = val * 1
    },
    async isThrowResumeBtn () {
      const isValid = await this.$refs.setDoneTime.validate()
      if (isValid) {
        this.editedFix.IsThrowToResume = true
        let response = await HttpFix.ThrowToResume(this.editedFix)
        if (response && response.status === 200) {
          await this.getFix()
          this.closeEditedFix()
          this.isShowThrowDialog = false
        }
      }
    },
    async isCancelBtn () {
      this.returnReason.Number = this.editedFix.Number
      this.returnReason.IsCancel = true
      await HttpFix.UpdateCancelReason(this.returnReason)
      this.returnReason = JSON.parse(JSON.stringify(this.defaultReason))
      await this.getFix()
      this.closeEditedFix()
      this.isShowCancelDialog = false
    },
    setCustomerDeviceTypeAutocomplete (event) {
      this.$refs.deviceTypeAutocomplete.isMenuActive = false
      this.$refs.deviceTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    async getCustomerDeviceType () {
      let response = await HttpQuotation.GetCustomerDeviceType()
      this.customerDeviceTypeList = response.status === 200 ? response.data.Data : 0
    },
    setEngineerAutocomplete (event) {
      this.$refs.engineerAutocomplete.isMenuActive = false
      this.$refs.engineerAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setFixTypeAutocomplete (event) {
      this.$refs.fixTypeAutocomplete.isMenuActive = false
      this.$refs.fixTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setZoneAutocomplete (event) {
      this.$refs.zoneAutocomplete.isMenuActive = false
      this.$refs.zoneAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setInstallPositionAutocomplete (event) {
      this.$refs.installPositionAutocomplete.isMenuActive = false
      this.$refs.installPositionAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setBuyOrRentTypeAutocomplete (event) {
      this.$refs.buyOrRentTypeAutocomplete.isMenuActive = false
      this.$refs.buyOrRentTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setKeyDownAutocomplete () {
      ///  儲存keydown之前的Roles
      this.specialNeedList = this.editedFix.SpecialNeedList
    },
    setKeyUpAutocomplete (event) {
      this.$refs.specialNeedAutocomplete.isMenuActive = false
      this.$refs.specialNeedAutocomplete.isFocused = false
      ///  塞回keydown之前的Roles  給KeyUp的Model editedUser.Roles
      this.editedFix.SpecialNeedList = this.specialNeedList
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (form[i].type !== 'hidden' && !form[i].disabled && form[i].type !== 'checkbox') {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    turnSpecialNeedName (value) {
      if (value) {
        let str = []
        let temp = 0
        value.forEach((element) => {
          str.push(element.Name)
          temp++
        })
        str = JSON.stringify(str)
        str = str.replace('[', '').replace(']', '')
        for (let index = 0; index < temp * 2; index++) {
          str = str.replace('"', '')
        }
        return str
      }
    },
    async getSpecialNeedList () {
      let response = await HttpSpecialNeed.GetSpecialNeed()
      this.allSpecialNeedList = response.status === 200 ? response.data.Data : []
    },
    async getEngineerUser () {
      let response = await HttpUser.GetEngineerUser()
      this.maintenanceEngineers = response.status === 200 ? response.data.Data : []
    },
    turnRecordType (item) {
      return RecordType.RecordTypeName(item)
    },
    turnZoneTypeName (val) {
      return ZoneType.ZoneTypeName(val)
    },
    // async deletePhoto (index) {
    //   await HttpFix.DeleteImage({
    //     fixNumber: this.editedFix.Number,
    //     fileName: this.editedFix.FileNameList[index]
    //   })
    //   this.editedFix.FileNameList.splice(index, 1)
    //   await HttpFix.UpdateFix(this.editedFix)
    //   await this.getPhoto()
    //   await this.searchFix()
    // },
    // async getPhoto () {
    //   if (this.editedFix.FileNameList && this.editedFix.FileNameList.length > 0) {
    //     let response = await HttpFix.GetImage({
    //       fixNumber: this.editedFix.Number,
    //       fixFileList: this.editedFix.FileNameList.join(',')
    //     })
    //     this.fixImageList = response.status === 200 ? response.data.Data : []
    //   }
    // },
    async uploadPhoto (event) {
      if (event.target.files.length > 0) {
        let formData = new FormData()
        for (var i = 0; i < event.target.files.length; i++) {
          formData.append('Files', event.target.files[i])
        }

        formData.append('Number', this.editedFix.Number)
        await HttpFix.UploadImage(formData)
        console.log(event.target.files)
        if (!this.editedFix.FileNameList) {
          this.editedFix.FileNameList = []
        }
        if (!this.editedFix.FileNameList) {
          this.editedFix.FileNameList = []
        }
        for (let i = 0; i < event.target.files.length; i++) {
          this.editedFix.FileNameList.push(event.target.files[i].name)
        }
        await HttpFix.UpdateFix(this.editedFix)
        // await this.getPhoto()
        await this.searchFix()
      }
    },
    openFileDialog () {
      this.$refs.file.click()
    },
    isOutOfWarrantyClass (item) {
      if (item.IsOutOfWarranty && item.BuyOrRentType === 1) {
        return 'red'
      }
    },
    async getZoneType () {
      let response = await HttpFix.GetZoneType()
      this.zoneList = response.status === 200 ? response.data.Data : []
    },
    turnBuyOrRentType (val) {
      return BuyOrRentType.BuyOrRentTypeName(val)
    },
    async setResumeItem () {
      this.editedFix.FixItems = []
      if (
        this.editedFix.FixType === this.fixType.TryInstallRepairFix &&
        this.editedFix.CustomerId &&
        this.editedFix.LicensePlate
      ) {
        let response = await HttpResume.GetOneResume({
          customerId: this.editedFix.CustomerId,
          licensePlate: this.editedFix.LicensePlate
        })
        let resume = response.status === 200 ? response.data.Data : {}
        if (response.status === 200) {
          this.editedFix.FirstContactName = resume.FirstContactName
          this.editedFix.FirstContactPhone = resume.FirstContactPhone
          this.editedFix.SecondContactName = resume.SecondContactName
          this.editedFix.SecondContactPhone = resume.SecondContactPhone
          this.editedFix.ThirdContactName = resume.ThirdContactName
          this.editedFix.ThirdContactPhone = resume.ThirdContactPhone
          this.editedFix.SpecialNeedList = resume.SpecialNeedList
          resume.ResumeItems.forEach((element) => {
            if (element.BuyOrRentType !== 3) {
              return
            }
            this.editedFix.FixItems.push({
              BomName: element.BomName,
              BomId: element.BomId,
              BomDescribe: element.BomDescribe,
              ItemId: element.ItemId,
              Number: element.Number,
              Name: element.Name,
              Unit: element.Unit,
              Quantity: element.Quantity,
              StoreNo: element.StoreNo,
              BuyOrRentType: element.BuyOrRentType,
              SerialNumber: element.SerialNumber ? element.SerialNumber.Number : '',
              IsCustomerDevice: element.IsCustomerDevice,
              InstallPosition: element.InstallPosition,
              Custody: element.Custody,
              Remark: element.Remark,
              WarrantyPeriod: 0
            })
          })
        }

        let param3 = {
          customerId: this.editedFix.CustomerId,
          licensePlate: this.editedFix.LicensePlate
        }
        let response3 = await HttpTpManager.GetOneTpManager(param3)
        if (response3.status === 200) {
          this.editedFix.TpAccount = response3.data.Data.Account
          this.editedFix.TpPassword = response3.data.Data.Password
        }
      }
    },
    async manyWork () {
      this.isShowStepDialog = true
      await this.getNotWorkFix()
    },
    setEditedItem (val) {
      this.editedFixItem.Id = val.Id
      this.editedFixItem.Number = val.Number
      this.editedFixItem.Name = val.Name
      this.editedFixItem.Unit = val.Unit
      this.editedFixItem.Price = val.Price
      this.editedFixItem.IsMonthItem = val.IsMonthItem
      this.editedFixItem.IsDelete = val.IsDelete
      this.editedFixItem.StoreNo = val.StoreNo
      this.editedFixItem.RepairPrice = val.RepairPrice
      this.editedFixItem.RepairWarrantyPeriod = val.RepairWarrantyPeriod
      this.editedFixItem.RentWarrantyPeriod = val.RentWarrantyPeriod
      this.editedFixItem.WarrantyPeriod = val.WarrantyPeriod
      this.editedFixItem.HasSerialNumber = val.HasSerialNumber
      this.editedFixItem.Type = val.Type
      this.editedFixItem.BuyOrRentType =
        val.Type === 'Z100000000' ? 2 : this.editedFixItem.BuyOrRentType
      if (val.HasSerialNumber) {
        this.editedFixItem.Quantity = 1
      }
      this.editedFixItem = JSON.parse(JSON.stringify(this.editedFixItem))
    },
    async setCustomer (val) {
      this.editedFix.CustomerId = val.Id
      this.editedFix.CustomerNumber = val.Number
      this.editedFix.CustomerName = val.ShortName
      this.editedFix.CustomerFullName = val.FullName
      this.editedFix = JSON.parse(JSON.stringify(this.editedFix))
    },
    async setFilterCustomer (val) {
      this.filterFix.CustomerId = val.Id
      this.filterFix = JSON.parse(JSON.stringify(this.filterFix))
      await this.getFix()
      await this.countTotalRows()
    },
    async getAllCustodyType () {
      let response = await HttpFix.GetCustodyType()
      this.allCustodyType = response.status === 200 ? response.data.Data : []
    },
    async getFixType () {
      let response = await HttpFix.GetFixeType()
      this.allFixType = response.status === 200 ? response.data.Data : []
    },
    turnFixType (val) {
      return FixType.FixTypeName(val.FixType)
    },
    async getAllInstallPositionType () {
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.allInstallPositionType = response.status === 200 ? response.data.Data : []
    },
    async getBuyOrRentType () {
      let response = await HttpInstallationAcceptance.GetBuyOrRentTypes()
      this.allBuyOrRentType = response.status === 200 ? response.data.Data : []
    },
    turnData (value) {
      if (value) {
        return ItemInstallPositionType.getFormInstallPositionTypeName(
          value,
          this.allInstallPositionType
        )
      }
    },
    checkSelected () {
      if (this.selectedWork.length !== 0) {
        this.stepNumber = 3
      } else {
        this.isSelectWorkNullDialog = true
      }
    },
    async manyPointAndMaintenanceEngineerUpdate () {
      this.selectedWork.forEach((element) => {
        element.IsWork = true
      })
      await HttpFix.UpdateFixList(this.selectedWork)
      await HttpFix.ThrowManyToRepair(this.selectedWork)
      await this.getFix()
      this.closeStepDialog()
    },
    updateEditedFixPoint () {
      this.selectedWork.splice(this.editedFixIndex, 1, this.editedFix)
      this.closeUpdateEditedFixPoint()
    },
    closeUpdateEditedFixPoint () {
      this.isShowNotWorkEditFixDialog = false
    },
    async giveMaintenanceEngineer () {
      const isValid = await this.$refs.dialogStepOne.validate()
      if (isValid) {
        this.stepNumber = 2
        this.notWorkFixList.forEach((element) => {
          element.MaintenanceEngineer = this.selectMaintenanceEngineer
          element.EngineerNickName = this.maintenanceEngineers.find(
            (x) => x.UserName === this.selectMaintenanceEngineer
          ).NickName
        })
      }
    },
    isShowNotWorkEditFixDialogBtn (item) {
      this.editedFixIndex = this.selectedWork.indexOf(item)
      let str = JSON.stringify(item)
      this.editedFix = JSON.parse(str)
      this.isShowNotWorkEditFixDialog = true
    },
    closeStepDialog () {
      this.isShowStepDialog = false
      this.selectedWork = []
      this.stepNumber = 1
      this.selectMaintenanceEngineer = ''
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultFix)
        this.editedFix = JSON.parse(str)
        this.editedFixIndex = -1
      })
    },
    async isWorkBtn () {
      if (this.editedFix.MaintenanceEngineer) {
        this.editedFix.IsWork = true
        await HttpFix.UpdateFix(this.editedFix)
        await HttpFix.ThrowToRepair(this.editedFix)
        await this.getFix()
        this.closeEditedFix()
      } else {
        alert(this.$t('fix_engineer_required'))
      }
    },
    async countTotalRows () {
      if (this.isUpdateEventTotal) {
        let param = {
          FixType: this.filterFix.FixType,
          FixNumber: this.filterFix.FixNumber,
          CustomerId: this.filterFix.CustomerId,
          LicensePlate: this.filterFix.LicensePlate,
          MaintenanceEngineer: this.filterFix.MaintenanceEngineer,
          FirstContactName: this.filterFix.FirstContactName,
          FirstContactPhone: this.filterFix.FirstContactPhone,
          SecondContactName: this.filterFix.SecondContactName,
          SecondContactPhone: this.filterFix.SecondContactPhone,
          CarPlace: this.filterFix.CarPlace,
          ZoneType: this.filterFix.ZoneType,
          SpecialNeedId: this.filterFix.SpecialNeedId,
          QuotationNumber: this.filterFix.QuotationNumber,
          StartQuotationNumber: this.filterFix.StartQuotationNumber,
          EndQuotationNumber: this.filterFix.EndQuotationNumber,
          IsRange: this.filterFix.IsRange
        }

        let response = await HttpFix.GetFixesCount(param)
        this.totalRows = response.status === 200 ? response.data.Data : 0
      }
    },
    updateOptions (val) {
      this.currentOptions = val
      this.isUpdateEventTotal = false
      this.getFix(val)
    },
    async setIsChange () {
      this.filterFix.QuotationNumber = ''
      this.filterFix.StartQuotationNumber = ''
      this.filterFix.EndQuotationNumber = ''
      await this.getFix()
    },
    async getNotWorkFix () {
      let response = await HttpFix.GetNotWorkFix()
      this.notWorkFixList = response.status === 200 ? response.data.Data : []
      this.notWorkFixList = this.notWorkFixList.filter((x) => !x.IsCancel)
    },
    async getFix (val) {
      if (this.isUpdateEventTotal) {
        this.currentOptions.page = 1
        this.countTotalRows()
      }
      this.isUpdateEventTotal = true
      this.isFixLoading = true
      let param = {
        FixType: this.filterFix.FixType,
        FixNumber: this.filterFix.FixNumber,
        CustomerId: this.filterFix.CustomerId,
        LicensePlate: this.filterFix.LicensePlate,
        MaintenanceEngineer: this.filterFix.MaintenanceEngineer,
        FirstContactName: this.filterFix.FirstContactName,
        FirstContactPhone: this.filterFix.FirstContactPhone,
        SecondContactName: this.filterFix.SecondContactName,
        SecondContactPhone: this.filterFix.SecondContactPhone,
        CarPlace: this.filterFix.CarPlace,
        ZoneType: this.filterFix.ZoneType,
        SpecialNeedId: this.filterFix.SpecialNeedId,
        QuotationNumber: this.filterFix.QuotationNumber,
        StartQuotationNumber: this.filterFix.StartQuotationNumber,
        EndQuotationNumber: this.filterFix.EndQuotationNumber,
        IsRange: this.filterFix.IsRange,
        ItemsPerPage:
          typeof val === 'object' && val ? val.itemsPerPage : this.currentOptions.itemsPerPage,
        Page: typeof val === 'object' && val ? val.page : this.currentOptions.page,
        SortBy:
          typeof val === 'object' && val && val.sortBy && val.sortBy[0]
            ? val.sortBy[0]
            : (this.currentOptions.sortBy && this.currentOptions.sortBy[0]) || 'Number',
        SortDesc:
          typeof val === 'object' && val && val.sortDesc && val.sortDesc[0] !== undefined
            ? val.sortDesc[0]
            : (this.currentOptions.sortDesc && this.currentOptions.sortDesc[0]) ?? true
      }
      let response = await HttpFix.GetFixes(param)
      this.fixList = response.status === 200 ? response.data.Data : []
      this.isFixLoading = false
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    async saveEditedFix () {
      const isValid = await this.$refs.dialogEditedFix.validate()
      if (isValid) {
        this.isLoadingSaveBtn = true
        this.isAllTextFieldDisable = true
        this.isFixLoading = true
        if (this.editedFixIndex !== -1) {
          await HttpFix.UpdateFix(this.editedFix)
        } else {
          await HttpFix.AddFix(this.editedFix)
        }
        await this.getFix()
        this.closeEditedFix()
      }
    },
    async searchFix () {
      let param = {
        id: this.editedFixIndex === -1 ? '' : this.editedFix.Id,
        number: this.editedFix.Number
      }
      let response = await HttpFix.SearchFix(param)
      this.editedFix = response.status === 200 ? response.data.Data : []
      this.editedFixIndex = this.fixList.findIndex((x) => x.Number === this.editedFix.Number)
      this.isFixLoading = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false
    },
    async closeEditedFix () {
      await this.getFix()
      this.isShowEditFixDialog = false
      this.isFixLoading = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultFix)
        this.editedFix = JSON.parse(str)
        this.editedTpManager = JSON.parse(JSON.stringify(this.defaultTpManager))
        this.editedFixIndex = -1
      })
    },
    async openEditedDialog () {
      let response = await HttpFix.MakeFixNumber()
      this.editedFix.Number = response.status === 200 ? response.data.Data : ''
      this.isShowEditFixDialog = true
    },
    async isShowEditFixDialogBtn (item) {
      this.editedFixIndex = this.fixList.indexOf(item)
      this.editedFix = JSON.parse(JSON.stringify(item))
      if (
        this.editedFix.FixType !== this.fixType.MovieLook &&
        this.editedFix.FixType !== this.fixType.Photo &&
        this.editedFix.FixType !== this.fixType.AuthorizeInstall &&
        this.editedFix.FixType !== this.fixType.AuthorizeRemove &&
        this.editedFix.FixType !== this.fixType.Info &&
        this.editedFix.FixType !== this.fixType.Prepayment &&
        this.editedFix.FixType !== this.fixType.Complaint
      ) {
        let response = await HttpFix.UpdateIsOutOfWarranty(item)
        this.editedFix = response.status === 200 ? response.data.Data : {}
      }
      if (this.editedFix.IsCancel || this.editedFix.IsThrowToResume) {
        this.isAllTextFieldDisable = true
      }

      // await this.getPhoto()
      this.isShowEditFixDialog = true
    },
    isShowDeleteFixDialogBtn (item) {
      this.editedFixIndex = this.fixList.indexOf(item)
      let str = JSON.stringify(item)
      this.editedFixItem = JSON.parse(str)
      this.isShowDeleteFixDialog = true
    },

    async confirmDeleteFix () {
      this.isLoadingSaveBtn = true
      await HttpFix.DeleteFix(this.fixList[this.editedFixIndex].Id)
      await this.getFix()
      this.closeDeleteFix()
    },
    closeDeleteFix () {
      this.isShowDeleteFixDialog = false
      this.isLoadingSaveBtn = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultFix)
        this.editedFix = JSON.parse(str)
        this.editedFixIndex = -1
      })
    },
    isShowEditFixItemDialogBtn (item) {
      this.editedFixItemIndex = this.computedFixItem.indexOf(item)
      let str = JSON.stringify(item)
      this.editedFixItem = JSON.parse(str)
      this.isShowEditFixItemDialog = true
    },

    isShowDeleteFixItemDialogBtn (item) {
      this.editedFixItemIndex = this.computedFixItem.indexOf(item)
      this.isShowDeleteFixItemDialog = true
    },

    confirmDeleteFixItem () {
      this.editedFix.FixItems.splice(this.editedFixItemIndex, 1)
      this.closeDeleteFixItem()
    },

    closeEditFixItem () {
      this.isShowEditFixItemDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultFixItem)
        this.editedFixItem = JSON.parse(str)
        this.editedFixItemIndex = -1
      })
    },

    closeDeleteFixItem () {
      this.isShowDeleteFixItemDialog = false
      this.$nextTick(() => {
        this.editedFixItemIndex = -1
      })
    },
    // 新增副品號的部分(儲存的部分)
    async addFixItem () {
      const isValid = await this.$refs.dialogEditedFixItem.validate()
      if (isValid) {
        if (this.editedFixItemIndex > -1) {
          this.editedFix.FixItems.splice(this.editedFixItemIndex, 1, this.editedFixItem)
        } else {
          this.editedFix.FixItems.push(this.editedFixItem)
        }
        this.closeEditFixItem()
      }
    },
    closeInfoDialog () {
      this.isShowCheckWorkPhoto = false
      this.isShowCheckDonePhoto = false
      this.infoMessage = ''
    },
    async checkWorkPhoto () {
      const isValid = await this.$refs.dialogEditedFix.validate()
      if (isValid) {
        if (!this.editedFix.FileNameList || this.editedFix.FileNameList.length === 0) {
          this.isShowCheckWorkPhoto = true
          this.infoMessage = this.$t('fix_no_photo_confirm_work')
        } else {
          await this.isWorkBtn()
        }
      }
    },
    async checkDonePhoto () {
      const isValid = await this.$refs.dialogEditedFix.validate()
      if (isValid) {
        if (!this.editedFix.FileNameList || this.editedFix.FileNameList.length === 0) {
          this.isShowCheckDonePhoto = true
          this.infoMessage = this.$t('fix_no_photo_confirm_done')
        } else {
          await this.updateDoneReason()
        }
      }
    },
    async checkThrowPhoto () {
      const isValid = await this.$refs.dialogEditedFix.validate()
      if (isValid) {
        if (!this.editedFix.FileNameList || this.editedFix.FileNameList.length === 0) {
          this.isShowCheckDonePhoto = true
          this.infoMessage = '此工單無照片，確定要完工'
        } else {
          await this.throwAuthorizeToResume()
        }
      }
    },
    async throwAuthorizeToResume () {
      this.editedFix.IsDone = true
      let response = await HttpFix.ThrowToResume(this.editedFix)
      if (response && response.status === 200) {
        await this.getFix()
        this.closeEditedFix()
      }
    },
    async updateDoneReason () {
      this.editedFix.IsDone = true
      if (
        this.editedFix.FixType === this.fixType.AuthorizeInstall ||
        this.editedFix.FixType === this.fixType.AuthorizeRemove
      ) {
        await this.throwAuthorizeToResume()
      } else {
        await HttpFix.UpdateFixDone(this.editedFix)
      }
      if (
        this.editedFix.TpAccount &&
        this.editedFix.TpPassword &&
        this.editedFix.FixType === this.fixType.Photo
      ) {
        let response = await HttpTpManager.GetOneTpManager({
          customerId: this.editedFix.CustomerId,
          licensePlate: this.editedFix.LicensePlate
        })
        if (response.status === 200) {
          this.editedTpManager = JSON.parse(JSON.stringify(response.data.Data))
          this.editedTpManager.Account = this.editedFix.TpAccount
          this.editedTpManager.Password = this.editedFix.TpPassword
          await HttpTpManager.UpdateTpManager(this.editedTpManager)
        } else {
          this.editedTpManager.CustomerId = this.editedFix.CustomerId
          this.editedTpManager.LicensePlate = this.editedFix.LicensePlate
          this.editedTpManager.Account = this.editedFix.TpAccount
          this.editedTpManager.Password = this.editedFix.TpPassword
          await HttpTpManager.AddTpManager(this.editedTpManager)
        }
      }
      await this.getFix()
      this.closeEditedFix()
    },
    deleteFixItems () {
      let array = []
      this.computedFixItem.forEach((element) => {
        let isExist =
          this.selectedFixItems.findIndex(
            (x) =>
              x.BomName === element.BomName &&
              x.InstallPosition === element.InstallPosition &&
              x.ItemId === element.ItemId
          ) !== -1
        if (!isExist) {
          array.push(element)
        }
      })
      this.editedFix.FixItems = JSON.parse(JSON.stringify(array))
      this.selectedFixItems = []
    },
    setInstallPositionListQuantity () {
      this.editedFixItemBom.Quantity = this.editedFixItemBom.InstallPositions.length
      this.editedFixItemBom = JSON.parse(JSON.stringify(this.editedFixItemBom))
    },
    setCustomerDeviceType (event) {
      this.$refs.deviceTypeAutocomplete.isMenuActive = false
      this.$refs.deviceTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setInstallPosition (event) {
      this.$refs.installPositionAutocomplete.isMenuActive = false
      this.$refs.installPositionAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setBuyOrRentType (event) {
      this.$refs.buyOrRentTypeAutocomplete.isMenuActive = false
      this.$refs.buyOrRentTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    changeBuyOrRentType () {
      this.editedFixItem.Unit = ''
      this.editedFixItem.Name = ''
      this.editedFixItemBom.Name = ''
      this.editedFixItemBom.Id = ''
      this.editedFixItemBom.Describe = ''
      if (this.editedFixItem.BuyOrRentType === 1) {
        this.editedFixItem.IsCustomerDevice = true
        this.editedFixItem.CustomerDeviceType = 3
      } else if (this.editedFixItemBom.BuyOrRentType === 1) {
        this.editedFixItemBom.IsCustomerDevice = true
        this.editedFixItemBom.CustomerDeviceType = 3
      }
    },
    setBomItem (val) {
      if (this.editedFixItemBom) {
        this.editedFixItemBom.Id = val.Id
        this.editedFixItemBom.Name = val.Name
        this.editedFixItemBom.Describe = val.Describe
        this.editedFixItemBom.BomItems = val.BomItems
      } else {
        this.editedFixItemBom.Id = ''
        this.editedFixItemBom.Name = ''
        this.editedFixItemBom.Describe = ''
        this.editedFixItemBom.BomItems = []
      }

      this.editedFixItemBom = JSON.parse(JSON.stringify(this.editedFixItemBom))
    },
    changeIsCustomerDevice () {
      if (this.editedFixItem.IsCustomerDevice) {
        this.editedFixItem.CustomerDeviceType = 3
      } else {
        this.editedFixItem.CustomerDeviceType = 0
      }

      if (this.editedFixItemBom.IsCustomerDevice) {
        this.editedFixItemBom.CustomerDeviceType = 3
      } else {
        this.editedFixItemBom.CustomerDeviceType = 0
      }
    },
    setInstallPositionQuantity () {
      if (this.editedFixItem.InstallPosition) {
        this.editedFixItem.Quantity = 1
      }
    },
    closeEditedFixItemBomDialog () {
      this.isShowFixItemEditedBomDialog = false
      this.$nextTick(() => {
        this.editedFixItemIndex = -1
        this.editedFixItemBom = JSON.parse(JSON.stringify(this.defaultFixItemBom))
      })
    },
    async addEditedFixItemBom () {
      const isValid = await this.$refs.bomRepairItem.validate()
      if (isValid) {
        this.computedFixItem.forEach((element) => {
          if (
            this.editedFixItemBom.Id === element.BomId &&
            this.editedFixItemBom.BuyOrRentType === element.BuyOrRentType
          ) {
            let index = this.editedFixItemBom.BomItems.findIndex((x) => x.Id === element.ItemId)
            if (index !== -1) {
              if (
                this.editedFixItemBom.InstallPositions &&
                this.editedFixItemBom.InstallPositions.length > 0
              ) {
                let idx = this.editedFixItemBom.InstallPositions.findIndex(
                  (x) => x === element.InstallPosition
                )
                if (idx !== -1) {
                  this.editedFixItemBom.InstallPositions.splice(idx, 1)
                  this.editedFixItemBom.Quantity--
                  if (this.editedFixItemBom.InstallPositions.length === 0) {
                    this.editedFixItemBom.BomItems.splice(index, 1)
                  }
                }
              } else {
                this.editedFixItemBom.BomItems.splice(index, 1)
              }
            }
          }
        })

        if (this.editedFixItemBom.BomItems.length !== 0) {
          if (
            this.editedFixItemBom.InstallPositions &&
            this.editedFixItemBom.InstallPositions.length > 0
          ) {
            this.editedFixItemBom.InstallPositions.forEach((ele) => {
              this.editedFixItemBom.BomItems.forEach((element) => {
                this.editedFix.FixItems.push({
                  BomName: this.editedFixItemBom.Name,
                  BomId: this.editedFixItemBom.Id,
                  BomDescribe: this.editedFixItemBom.Describe,
                  ItemId: element.Id,
                  Number: element.Number,
                  Name: element.Name,
                  Unit: element.Unit,
                  Quantity:
                    (element.Quantity * this.editedFixItemBom.Quantity * 1) /
                    this.editedFixItemBom.InstallPositions.length,
                  BuyOrRentType: this.editedFixItemBom.BuyOrRentType,
                  SerialNumber: '',
                  IsCustomerDevice: this.editedFixItemBom.IsCustomerDevice,
                  InstallPosition: ele,
                  Custody: 0,
                  Remark: '',
                  WarrantyPeriod: 0,
                  IsOutOfWarranty: false,
                  CustomerDeviceType: this.editedFixItemBom.CustomerDeviceType
                })
              })
            })
          } else {
            this.editedFixItemBom.BomItems.forEach((element) => {
              this.editedFix.FixItems.push({
                BomName: this.editedFixItemBom.Name,
                BomId: this.editedFixItemBom.Id,
                BomDescribe: this.editedFixItemBom.Describe,
                ItemId: element.Id,
                Number: element.Number,
                Name: element.Name,
                Unit: element.Unit,
                Quantity: element.Quantity * this.editedFixItemBom.Quantity * 1,
                BuyOrRentType: this.editedFixItemBom.BuyOrRentType,
                SerialNumber: '',
                IsCustomerDevice: this.editedFixItemBom.IsCustomerDevice,
                InstallPosition: element.InstallPosition,
                Custody: 0,
                Remark: '',
                WarrantyPeriod: 0,
                IsOutOfWarranty: false,
                CustomerDeviceType: this.editedFixItemBom.CustomerDeviceType
              })
            })
          }
        }
        this.closeEditedFixItemBomDialog()
      }
    },
    async cleanSelectedAuthFixList () {
      this.selectedAuthFixList = []
      await this.getFix()
    },
    async updateSelectedAuthFixList (selectedAuthFixDoneList) {
      selectedAuthFixDoneList.forEach((element) => {
        let selectedAuthFixIndex = this.selectedAuthFixList.findIndex((x) => x.Id === element.Id)
        if (selectedAuthFixIndex !== -1) {
          this.selectedAuthFixList[selectedAuthFixIndex] = JSON.parse(JSON.stringify(element))
        }
      })
      this.selectedAuthFixList = JSON.parse(JSON.stringify(this.selectedAuthFixList))
      await this.getFix()
    },
    async updateSelectedAuthFix (val) {
      let fixIndex = this.selectedAuthFixList.findIndex((x) => x.Id === val.Id)
      this.selectedAuthFixList[fixIndex] = val
      this.selectedAuthFixList = JSON.parse(JSON.stringify(this.selectedAuthFixList))
      await this.getFix()
    }
  }
}
</script>
